import { bool, node, number, oneOf } from 'prop-types'

import {
  AVAILABLE_PRESCRIPTION_TYPES,
  AVAILABLE_PRODUCT_TEMPLATES,
  PRESCRIPTION_TYPE_FREE,
  PRESCRIPTION_TYPE_INSURANCE,
  PRESCRIPTION_TYPE_NO_PRESCRIPTION,
  PRESCRIPTION_TYPE_PRIVAT,
} from 'shared/consts/productTemplates'
import DiscountBadge from 'views/components/atoms/DiscountBadge'
import Price from 'views/components/atoms/Price'
import RoundBadge from 'views/components/atoms/RoundBadge'
import { getBadgeColor } from 'views/components/organisms/ProductVariants/ProductVariant/helpers'

const ProductVariantBadge = ({
  discount,
  productTemplate,
  prescriptionType,
  isOutOfStock,
  bonus,
  showSupNotes,
  children,
  ...rest
}) => {
  const props = {
    showSupNotes,
    ...rest,
  }

  let badge
  let Component

  if (
    [
      PRESCRIPTION_TYPE_INSURANCE,
      PRESCRIPTION_TYPE_FREE,
      PRESCRIPTION_TYPE_PRIVAT,
    ].includes(prescriptionType)
  ) {
    Component = RoundBadge
    badge = <Price amount={bonus} />

    props.color = getBadgeColor(productTemplate, bonus)
    props.size = 'large'
  } else {
    if (!discount) {
      return (
        <span className="a-h2 u-color--grey u-padding-x-large--right o-ProductVariantBadge__no-discount">
          --
        </span>
      )
    }

    Component = DiscountBadge
    badge = <>&minus;{discount}%</>

    props.color = 'red'
    props.discount = discount
    props.ellipse = true
  }

  if (isOutOfStock) {
    props.color = 'grey'
  }

  return (
    <div className="o-ProductVariantBadge l-flex l-flex--justify-content--end">
      <Component {...props}>
        {badge}
        {children}
      </Component>
    </div>
  )
}

ProductVariantBadge.propTypes = {
  isOutOfStock: bool.isRequired,
  discount: number,
  bonus: number,
  productTemplate: oneOf(AVAILABLE_PRODUCT_TEMPLATES).isRequired,
  prescriptionType: oneOf(AVAILABLE_PRESCRIPTION_TYPES.ALL),
  showSupNotes: bool,
  children: node,
  isMasterPage: bool,
  lowestPrice: number,
}

ProductVariantBadge.defaultProps = {
  prescriptionType: PRESCRIPTION_TYPE_NO_PRESCRIPTION,
  discount: null,
  bonus: null,
  showSupNotes: false,
  children: null,
  isMasterPage: false,
}

export default ProductVariantBadge
